import { readAsDataUrlAsync } from '@/composables/file-upload'

export const useCamera = () => {
  const readImageAsync = (event) => {
    const file = event.target.files[0]
    event.target.value = ''
    if (!file) return Promise.resolve(null)

    return readAsDataUrlAsync(file).then(dataUrl => ({ name: file.name, dataUrl }))
  }

  const applyImage = (editItem, name, dataUrl) => {
    editItem.avatar_file = { name, payload: dataUrl }
  }

  return {
    readImageAsync,
    applyImage,
  }
}
